/** @jsxImportSource @emotion/react */

import { userAtom } from '@app/hooks/useUserProfile'
import { UserRole } from '@app/types'
import { ArrowBack, Settings } from '@mui/icons-material'
import AddIcon from '@mui/icons-material/Add'
import { Box, Button } from '@mui/material'
import { useAtomValue } from 'jotai'
import { Link, Outlet, useLocation } from 'react-router-dom'

export const DataLayerDetailSuitability = () => {
  const { data: user } = useAtomValue(userAtom)
  const isAdmin = user?.user_roles.includes(UserRole.ADMIN)

  const location = useLocation()
  const isSuitabilityRoute = location.pathname.endsWith('/suitability')
  const isCreateRoute = location.pathname.endsWith('/create')
  const isSettingsRoute = location.pathname.endsWith('/settings')

  return (
    <div>
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          flexWrap: 'wrap',
          mb: 3,
          justifyContent: 'space-between',
          marginTop: 2,
        }}
      >
        {isCreateRoute ||
          (isSettingsRoute && (
            <Link to="">
              <Button variant="outlined" size="small" startIcon={<ArrowBack />}>
                Back
              </Button>
            </Link>
          ))}
        {isSuitabilityRoute && (
          <Link to="create">
            <Button variant="contained" size="small" startIcon={<AddIcon />}>
              Create suitability
            </Button>
          </Link>
        )}

        {isAdmin && !isSettingsRoute && !isCreateRoute && (
          <Link to="settings">
            <Button variant="contained" size="small" startIcon={<Settings />}>
              Settings
            </Button>
          </Link>
        )}
      </Box>
      <Outlet />
    </div>
  )
}

export default DataLayerDetailSuitability
